import { api } from './auth.service';

const grupoAcessoService = {

  listar: async () => {
    const res = await api.get('/grupos-acesso');
    return res.data;
  },

  buscarPorId: async (id) => {
    const res = await api.get(`/grupos-acesso/${id}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/grupos-acesso', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/grupos-acesso/${id}`, dados);
    return res.data;
  },

  // Permissões do grupo
  listarPermissoes: async (id) => {
    const res = await api.get(`/grupos-acesso/${id}/permissoes`);
    return res.data;
  },

  salvarPermissoes: async (id, permissoes) => {
    const res = await api.post(`/grupos-acesso/${id}/permissoes`, { permissoes });
    return res.data;
  },
};

export default grupoAcessoService;
